function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";

//Limitless imports
import ExtraInfoTableView from "./extra-info/ExtraInfoTableView";
import ExtraInfoDetailView from "./extra-info/ExtraInfoDetailView";
import { useExpertMessageExtraInfoContext } from "../../../../expert";
import { log as pilog } from "@limitless/common/utils";
const ExtraCustomerInfo = () => {
  const log = pilog.getLogger("ExtraCustomerInfo");
  const {
    updateInfoCriteria,
    onValueCopied,
    onUpdateSelectedItem,
    ...rest
  } = useExpertMessageExtraInfoContext();
  log.debug(rest);
  if (rest.selected !== null) {
    return /*#__PURE__*/React.createElement(ExtraInfoDetailView, _extends({}, rest, {
      updateInfoCriteria: () => onUpdateSelectedItem({
        selected: null
      }),
      onValueCopied: onValueCopied
    }));
  }
  return /*#__PURE__*/React.createElement(ExtraInfoTableView, _extends({}, rest, {
    updateInfoCriteria: updateInfoCriteria,
    onValueCopied: onValueCopied,
    onUpdateSelectedItem: onUpdateSelectedItem
  }));
};
export default ExtraCustomerInfo;